import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const AuthLayout = () => {
  const theme = useTheme();
  return (
<div style={{ backgroundColor: theme.palette.common.white, }}>
        <Outlet />
        </div>

  );
};

export default AuthLayout;